import Identifiable from "../models/base/Identifyable";
import { Pagination, PaginationQuery } from "../models/base/Pagination";
import RequestMethod from "../models/client/RequestMethod";
import RestResponse, { responseFromError } from "../models/client/RestResponse";
// import { toPascalCase } from "../utils/stringConvert";

import { RestClient } from "./restClient";

export type RequestFunction<Request> = {
  (element: Partial<Request>): RestResponse<Request>;
};

/* export type GetManyRequestFunction<T> = {
  (): RestResponse<T[]>;
}; */

/* export type IdListRequestFunction<T> = {
  (id: string): RestResponse<T[]>;
}; */

export type IdRequestFunction<Response> = {
  (id: string): RestResponse<Response>;
};

/* export type BindOneFunction<Response> = {
  (relationId: string, elementId: string): RestResponse<Response>;
}; */

export type PaginationRequestFunction<Response> = {
  (
    params: PaginationQuery,
    signal?: AbortSignal
  ): RestResponse<Pagination<Response>>;
};

export type CrudServiceType<Request extends Partial<Identifiable>> = {
  path: string;
  /* queryMany: GetManyRequestFunction<Required<Request>>; */
  queryPagination: PaginationRequestFunction<Request>;
  querySingle: IdRequestFunction<Request>;
  create: RequestFunction<Request>;
  update: RequestFunction<Request>;
  delete: RequestFunction<{ id?: string } | string>;
};

export const handlePaginationQuery = (params: PaginationQuery) => {
  // Extract filters from params and remove them from the original params
  const { filters: columnFilters, ...restParams } = params;

  // Initialize URLSearchParams with the rest of the params
  const queryParams = new URLSearchParams();

  // Add the non-filter params to the query
  Object.entries(restParams).forEach(([key, value]) => {
    if (value !== undefined && value !== null) {
      queryParams.append(key, String(value));
    }
  });

  // Convert ColumnFiltersState to the backend format
  if (columnFilters) {
    columnFilters.forEach((filter) => {
      const key = `Filters[${filter.id}]`;
      const value = filter.value;

      if (Array.isArray(value)) {
        // Add each value as a separate query parameter
        value.forEach((v) => queryParams.append(key, String(v)));
      } else {
        // Add the single value as a query parameter
        queryParams.append(key, String(value));
      }
    });
  }

  // Build the complete query string
  return queryParams.toString();
};

export function crudService<Request extends Partial<Identifiable>>(
  client: RestClient,
  path: string
): CrudServiceType<Request> {
  const elementPath = (id: string) => "" + path + "/" + id;
  return {
    path,
    /*  async queryMany() {
      return await client.fetch(RequestMethod.GET, path);
    }, */
    async queryPagination(params: PaginationQuery, signal?: AbortSignal) {
      // Pass the signal to the fetch request
      return client.fetch(
        RequestMethod.GET,
        `${path}?${handlePaginationQuery(params)}`,
        undefined,
        undefined,
        undefined,
        undefined,
        { signal }
      );
    },
    async querySingle(id: string) {
      if (!id) return responseFromError(400);
      return client.fetch(RequestMethod.GET, elementPath(id));
    },
    async create(element) {
      return client.fetch(RequestMethod.POST, path, element);
    },
    async update(element) {
      const { id, ...rest } = element;
      if (!id) return responseFromError(400);
      return client.fetch(RequestMethod.PUT, elementPath(id), rest);
    },
    async delete(value) {
      const id = typeof value === "string" ? value : value.id;
      if (!id) return responseFromError(400);
      return await client.fetch(RequestMethod.DELETE, elementPath(id));
    },
  };
}
